export default "__VITE_ASSET__S9YOFbYz__"